import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

const UnauthorizedPage = () => {
  const { handleLogout } = useAuth();

  useEffect(() => {
    // 一旦進入 UnauthorizedPage，就執行登出並導向登入頁面
    handleLogout();
    window.location.href = '/login';
  }, [handleLogout]);

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>未授權的訪問</h1>
      <p>您沒有權限訪問該頁面，系統將自動登出並導向登入頁面…</p>
    </div>
  );
};

export default UnauthorizedPage;
